<div class="cf-flex-column group-layout" [id]="'data-' + groupType.Key">
  <div class="mat-headline-6">{{ groupType.NameId | translate }}</div>
  <div class="cf-flex-row cf-flex-wrap">
    <ng-container *ngFor="let propertyType of groupType.Properties">
      <div
        *ngIf="entity.Properties[propertyType.Key].Rules.VisibleIf"
        [class]="`property-layout property-${propertyType.Key}-style`"
        [ngClass]="{
          'button-property': isButton(propertyType),
          'form-field-property': !isButton(propertyType),
          'property-grow': getUIWidth(propertyType) === 'auto'
        }"
        [ngStyle]="{ 'flex-basis': getUIWidth(propertyType) }"
      >
        <app-entity-property-wrapper
          [entity]="entity"
          [entityForm]="entityForm"
          [propertyType]="propertyType"
          [propertyComponent]="propertyEditorComponent"
          (propertyChange)="propertyChange.emit($event)"
        >
        </app-entity-property-wrapper>
      </div>
    </ng-container>
  </div>
</div>
